import { render, staticRenderFns } from "./scheduleClassesDay.vue?vue&type=template&id=31bb2868&scoped=true"
import script from "./scheduleClassesDay.vue?vue&type=script&lang=js"
export * from "./scheduleClassesDay.vue?vue&type=script&lang=js"
import style0 from "./scheduleClassesDay.vue?vue&type=style&index=0&id=31bb2868&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31bb2868",
  null
  
)

export default component.exports